import request from '@/utils/request'
import { baseURL } from '@/utils/getawayModule'

/***
 *
 * 根据用户用户ID查询打球人
 * @param userId 用户ID
 * @return request
 * */
export function getContactPersonsByUserId(userId) {
  return request({
    url: `${baseURL.businessApi}/contact_persons/byUserId?userId=${userId}`,
    method: 'get'
  })
}

/***
 *
 * 增加打球人
 * @param data 添加数据
 * @return request
 * */
export function addContactPersons(data) {
  return request({
    url: `${baseURL.businessApi}/contact_persons/byUserId`,
    method: 'post',
    data: data
  })
}